import jsonApi from '../../utils/jsonApi'

export const getPAChild = ({ page, params }) => {
  return jsonApi
    .findAll('pickup_authorization_children', {
      params: {
        'q[s]': 'created_at desc',
        'page[number]': page || 1,
        ...params
      }
    })
    .then(res => res)
}
